import { useEffect } from "react";
import { Page } from "../../Page";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { resetButtons, setBackButtonVisible, setHomeButtonVisible, setPromptOkCancelOnHome } from "../menu/menuSlice";
import styles from './Wizard.module.css';
import {  selectCurrentPartyEventLocation, setEventLocation, selectCurrentPartyEvent } from "../currentPartyEvent/currentPartyEventSlice";
import { useNavigate } from "react-router-dom";
import { setMessage } from "../messageBoxes/messageBoxSlice";
import { BackButton } from "../menu/BackButton";

export function Location() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const eventLocation = useAppSelector(selectCurrentPartyEventLocation)
    const currentPartyEvent = useAppSelector(selectCurrentPartyEvent)
    useEffect(() => {
        dispatch(resetButtons())
        dispatch(setBackButtonVisible(true))
        dispatch(setHomeButtonVisible(true))
        dispatch(setPromptOkCancelOnHome(true))
        dispatch(setMessage('Cancel saving this event and return to the home page?'))
    })
    return(
        <Page> 
            <div className={styles.bannerContainer}>
                <div>
                    <h2>PartyPlanner.</h2>
                        <h4>Organise, invite and celebrate in style.</h4>
                </div>
                <div className={styles.bannerButton}>
                    <BackButton/>
                </div>
            </div>
            <div className={styles.header}>
            <h1> PartyPlanner</h1>
            <br></br>
            <h2>Where is your party going to be held?</h2>
            <br></br>
            <p>(Type the address and postcode underneath)</p>
            </div>
            <label className={styles.label} htmlFor='txtEventLocation'>Location:</label>
            <input
                placeholder="Type Location here"
                id='txtEventLocation'
                className={styles.textbox}
                aria-label="Set Location"
                value={eventLocation}
                onChange={(e) => dispatch(setEventLocation(e.target.value))}
                />
                <br></br>
                <button className={styles.nextButton} onClick={() => {
                    if (!currentPartyEvent?.location ) {
                        alert('Please give your party a location, this is required.')
                        return
                    }
                navigate('/CreateEndTime')
                }}>Next</button>
        </Page>
    )
}
